import React from 'react';

// Styles
import './App.css';

// Data
import data from "./data/data.js";

// Components
import Hero from './components/Hero/Hero';
import Categories from './components/CategorySection/CategorySection';
// import Sweepstakes from './components/SweepstakesSection/Sweepstakes';
// import Wordaful from './components/WordafulSection/Wordaful';
import GetMore from './components/GetMoreSection/GetMore';
import DownloadWrapper from './components/DownloadWrapper/DownloadWrapper';
// import SocialFeed from './components/SocialFeed/Social';

require('dotenv').config();

function App() {
  return (
    <div className="App">
      {/* <JsonTest /> */}
      <Hero data={data.heroSection} />
      <Categories data={data.categorySection} />
      {/*<Sweepstakes data={data.sweepstakesSection} />*/}
      {/*<Wordaful data={data.wordafulSection} />*/}
      {/* <SocialFeed data={data.socialFeed} /> */}
      <DownloadWrapper data={data.downloadWrapper} />
      <GetMore data={data.getMore} />
    </div>
  );
}

export default App;
